
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";

// import * as api from "../constant/API";
import Utils from "../constant/Utils";

const Support = () => {

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState("");
    const [supportCaseList, setSupportCaseList] = useState([]);

    useEffect(() => {
        getSupportCaseList()
    }, [])

    function getSupportCaseList() {
        const getCaseLst = api.supportCaseList //+ "?userId=" + userId;
        fetch(getCaseLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                // console.log("Result",lstResult.data);
                if (lstResult.data != null) {
                    setSupportCaseList(lstResult.data)
                }
                
            })
            .catch((error) => {
                console.log("Failed to fetch the institution manager list", error)
            })
    }

    const filteredData = supportCaseList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const instituteRender = (rowData) => {
        return <span>{rowData.InstitutionName}</span>
    }

    const sprtRender = (rowData) => {
        return <span>{rowData.SportName}</span>
    }

    const coachRender = (rowData) => {
        return <span>{rowData.CoachName}</span>
    }

    return (
        <>
            <div className="content-container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row d-flex align-items-center">
                                                            <h3 className="text-center mb-40">
                                                                <i className="fas fa-headset" />
                                                                Support Cases
                                                            </h3>
                                                        </div>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-6">
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="dataTables_filter">
                                                                    <label>
                                                                        <input
                                                                            type="text"
                                                                            value={searchInput}
                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                            placeholder="Search"
                                                                            className="form-control"
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-content">
                                                        <div
                                                            className="tab-pane fade show active"
                                                            id="nav-Recent"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-Recent-tab"
                                                            tabIndex={0}
                                                        >
                                                            <div className="table-responsive table-datatble">
                                                                <DataTable
                                                                    className="table datatable"
                                                                    value={filteredData}
                                                                    paginator
                                                                    rows={10}
                                                                    rowsPerPageOptions={[10, 25, 50]}
                                                                    currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                >
                                                                    <Column
                                                                        sortable
                                                                        field="slNo"
                                                                        // body={slNoRender}
                                                                        headerClassName="text-uppercase"
                                                                        header="Sl &nbsp; No"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        field="supportCaseName"
                                                                        headerClassName="text-uppercase"
                                                                        header="Support Case Name"
                                                                    // body={nameRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        field="user"
                                                                        headerClassName="text-uppercase"
                                                                        header="User"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        field="status"
                                                                        headerClassName="text-uppercase"
                                                                        header="Status"
                                                                    ></Column>
                                                                    <Column 
                                                                    sortable
                                                                    ></Column>
                                                                    <Column 
                                                                    sortable
                                                                    ></Column>
                                                                    <Column 
                                                                    sortable
                                                                    ></Column>
                                                                    <Column 
                                                                    sortable
                                                                    ></Column>
                                                                </DataTable>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Support;